<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    contentList: {
        type: Array,
        default: () => []
    }
})

const resolvedTitle = computed(() => props.title || t('ProductSpecs.rows.dataInterface'))
const resolvedContentList = computed(() => (
    props.contentList.length
        ? props.contentList
        : [
            t('ProductSpecs.values.rtcmGgaOutput'),
            t('ProductSpecs.values.insGnssImuOutput')
        ]
))
</script>

<template>
    <div class="table-line">
        <div class="table-line__container">
            <div class="table-line__title text-size-24">
                {{ resolvedTitle }}
            </div>
            <div class="table-line__content">
                <div class="table-line__list">
                    <div v-for="(content, index) in resolvedContentList" :key="index" class="table-line__item text-size-20">

                        <span>{{ content }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.table-line {
    width: 100%;
    border-bottom: 1px solid #e5e7eb;
}

.table-line__container {
    display: flex;
    padding: 40px 0;
}

.table-line__title {

    text-align: left !important;
    width: 40%;
    font-weight: bold;
    color: rgb(0, 0, 0);
}

.table-line__content {
    text-align: left !important;

    width: 75%;

    color: rgba(89, 89, 89,1);

}

.table-line__list {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.table-line__item {
    display: flex;
    align-items: flex-start;
}

.table-line__bullet {
    margin-right: 4px;
}

@media (max-width: 768px) {
    .table-line__container {
        display: flex;
        flex-direction: column;
        padding: 20px 0;
    }

}



</style>
